export const getPXLProfileRoute = () => '/profile';